<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>初始化数据</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      初始化数据
      <div class="title-btn">
        <el-button
          type="warning"
          plain
          @click="openInitData"
          v-if="$store.state.funcModuleArray.includes(1901020601)"
          >初始化数据</el-button
        >
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" :model="filterForm">
            <el-form-item label="状态">
              <el-select size="small" v-model="filterForm.status">
                <el-option label="全部" value="-1"></el-option>
                <el-option
                  :label="item.value"
                  :value="item.key"
                  v-for="item in StatusList"
                  :key="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="初始化时间 ">
              <el-date-picker
                value-format="yyyy-MM-dd"
                size="small"
                v-model="filterForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期 "
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item v-if=" $store.state.companyInfo.account_row.show_file_diff==1" label="是否对比差异">
              <el-select size="small" v-model="filterForm.is_diff">
                <el-option label="全部" value=""></el-option>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="filterForm.search_text"
                class="search-text"
                size="small"
                style="width: 450px;margin-bottom: 3px;"
                placeholder="请输入经销商名称/经销商编码/子公司名称/失败原因/备注"
              >
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条结果</div>
          <el-table
            v-loading="tableDataLoading"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column width="150" prop="create_time" label="初始化时间">
            </el-table-column>
            <el-table-column width="100" prop="realname" label="操作人">
            </el-table-column>
            <el-table-column width="100" prop="broker_code" label="经销商编码">
            </el-table-column>
            <el-table-column prop="client_name" label="经销商名称">
            </el-table-column>
            <el-table-column prop="subsidiarynames" label="子公司名称">
              <template slot-scope="scope">
                <div
                  class="clamp-2"
                  :title="titleMultiLine(scope.row.subsidiarynames)"
                >
                  {{ scope.row.subsidiarynames }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="status" label="初始化状态">
              <template slot-scope="scope">
                <el-tag
                  style="
                    color: #02a7f0;
                    background-color: #ddf5ff;
                    border-color: #ddf5ff;
                  "
                  v-if="scope.row.status == 0"
                  >{{ scope.row.status_desc }}</el-tag
                >
                <el-tag
                  v-else-if="scope.row.status == 1"
                  style="
                    color: #9ced25;
                    background-color: #effdda;
                    border-color: #effdda;
                  "
                  >{{ scope.row.status_desc }}</el-tag
                >
                <el-tag
                  style="
                    color: #f57586;
                    background-color: #f9d9dd;
                    border-color: #f9d9dd;
                  "
                  v-else
                  >{{ scope.row.status_desc }}</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column v-if=" $store.state.companyInfo.account_row.show_file_diff==1" prop="is_diff" label="是否对比差异">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.is_diff == 1 ? "是" : "否" }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="error_msg" label="失败原因">
            </el-table-column>
            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                <div class="clamp-2" :title="titleMultiLine(scope.row.remark)">
                  {{ scope.row.remark }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage > 1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
    <el-dialog title="初始化数据设置" :visible.sync="dialogVisible" width="70%">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <div class="card-content">
          <el-form-item label="经销商" prop="selectDealer">
            <el-tag
              style="
                background-color: #f09601;
                color: #fff;
                padding: 0 15px;
                cursor: pointer;
              "
              type="primary"
              @click="openChooseDealer"
              >选择</el-tag
            >
            <div>
              <el-tag v-if="form.selectDealer !== ''">{{
                form.selectDealer
              }}</el-tag>
            </div>
          </el-form-item>
          <el-form-item v-if="subsidiaryCount > 0" label="子公司">
            <el-tag
              style="
                background-color: #f09601;
                color: #fff;
                padding: 0 15px;
                cursor: pointer;
              "
              type="primary"
              @click="openChooseSubsidiary"
              >选择</el-tag
            >
            <div style="display: flex; flex-wrap: wrap">
              <div v-for="item in selectAboutList" :key="item.index">
                <el-tag style="margin: 0 10px 0 0">{{
                  item.subsidiary_name
                }}</el-tag>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="是否对比差异" v-if=" $store.state.companyInfo.account_row.show_file_diff==1" prop="is_diff">
            <el-radio-group v-model="form.is_diff">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" class="new-textarea" prop="clientText">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.clientText"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <choose-single-dealer
      ref="chooseSingleDealer"
      @saveChange="dealerSaveChange"
      :is-clear-search-text="true"
      :is-checkbox="false"
      :type="filterForm.status"
    ></choose-single-dealer>
    <SelectSummyModal
      :clientId="clientID"
      ref="SelectSummyModal"
      @save="saveSummy"
    ></SelectSummyModal>
  </div>
</template>

<script>
import {
  webScrapClientInitList,
  enumBusinessList,
  AddwebScrapClientInit,
  SplitgetSplitFileInfo,
} from "@/api/index";
import ChooseSingleDealer from "@/components/ChooseSingleDealer";
import SelectSummyModal from "@/components/SelectSummyModal";
import { titleMultiLine } from "@/util";
export default {
  name: "InitializationData",
  components: {
    ChooseSingleDealer,
    SelectSummyModal,
  },
  data: () => ({
    currentPage: 1,
    totalCount: 0,
    tableData: [],
    selectionVal: [],
    totalPage: 1,
    reportTypeMap: [],
    filterForm: {
      status: "-1",
      date: "",
      is_diff: "",
      search_text: "",
    },
    dialogVisible: false,
    loading: false,
    rules: {
      selectDealer: [
        { required: true, message: "请选择经销商", trigger: "blur" },
      ],
      is_diff: [
        { required: true, message: "请选择是否对比差异", trigger: "blur" },
      ],
    },
    form: {
      selectDealer: "",
      clientText: "",
      is_diff: '0'
    },
    selectAboutList: [],
    StatusList: [],
    tableDataLoading: false,
    clientID: 0,
    subsidiaryCount: 0,
  }),
  created() {
    let query = this.$route.query;
    if (query.collect_type) {
      this.openInitData();
    }
  },
  mounted() {
    this.getenumBusinessList();
  },
  methods: {
    titleMultiLine,
    getenumBusinessList() {
      let par = {
        enum_name_arr: ["WebScrapClientInitStatusEnum"],
      };
      enumBusinessList(par).then((res) => {
        if (res.status == 0) {
          this.StatusList = res.data[0].WebScrapClientInitStatusEnum;
          console.log(this.StatusList);
          this._getList(1);
        }
      });
    },
    _getList(page) {
      this.tableDataLoading = true;
      let filterForm = { ...this.filterForm };
      if (filterForm.date && filterForm.date !== "") {
        filterForm.start_date = filterForm.date[0];
        filterForm.end_date = filterForm.date[1];
      } else {
        filterForm.start_date = "";
        filterForm.end_date = "";
      }
      delete filterForm.date;
      filterForm.page = page;
      filterForm.status = !filterForm.status ? "0" : filterForm.status;
      webScrapClientInitList(filterForm).then((res) => {
        this.tableDataLoading = false;
        if (0 === res.status) {
          let list = res.data.list;

          for (const item of list) {
            let subsidiaryNameArr = [];
            if (item.subsidiary.length) {
              for (const item1 of item.subsidiary) {
                subsidiaryNameArr.push(item1.subsidiary_name);
              }
              item.subsidiarynames = subsidiaryNameArr.join(",");
            } else {
              item.subsidiarynames = "";
            }
          }
          console.log(list, "listlistlist");
          this.tableData = list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    onSearch() {
      this._getList(1);
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let values = { ...this.form };
          let subClientArr = [];
          for (const item of this.selectAboutList) {
            if (item.client_id != "all") {
              subClientArr.push(item.client_id);
            }
          }
          let parameter = {
            client_id: this.selectionVal[0].client_id,
            remark: values.clientText,
            client_name: this.selectionVal[0].client_name,
            client_code: this.selectionVal[0].client_code,
            sub_client_id_list: subClientArr.join(","),
            broker_code: this.selectionVal[0].broker_code,
            is_diff: values.is_diff,
          };
          AddwebScrapClientInit(parameter).then((res) => {
            this.loading = false;
            this.dialogVisible = false;
            if (0 === res.status) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
              this.$message.error(res.msg);
            }
          });
          this._getList(1);
        }
      });
    },
    openChooseDealer() {
      console.log(this.selectionVal, "ssssss");
      this.$refs.chooseSingleDealer.openDialog(this.selectionVal);
    },
    dealerSaveChange(selectionVal) {
      this.selectionVal = selectionVal;
      this.selectAboutList = [];
      console.log(selectionVal, "selectionValselectionVal");
      this.clientID = Number(selectionVal[0].client_id);
      this.broker_code = selectionVal[0].broker_code;
      this.form.selectDealer = selectionVal[0].client_name;
      SplitgetSplitFileInfo("", this.clientID, "1,3", this.broker_code).then(
        (res) => {
          if (res.status === 0) {
            if (res.data.client) {
              this.subsidiaryCount = res.data.subsidiary.length;
            } else {
              this.subsidiaryCount = 0;
            }
          } else {
            this.subsidiaryCount = 0;
          }
        }
      );
    },
    openInitData() {
      this.selectionVal = [];
      this.form.selectDealer = "";
      this.form.clientText = "";
      this.loading = false;
      this.selectAboutList = [];
      this.subsidiaryCount = 0;
      this.dialogVisible = true;
    },
    // 选择子公司
    openChooseSubsidiary() {
      this.$refs.SelectSummyModal.openModal(this.selectAboutList);
    },
    // 选择子公司回调
    saveSummy(e) {
      this.selectAboutList = [...e];
      console.log(e, "Eeeeeeee");
    },
  },
};
</script>

<style scoped>
.clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
